document.addEventListener('DOMContentLoaded', () => {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event.source !== 'product-form') return;

    const checkedBoxes = Array.from(document.querySelectorAll('.addon-checkbox:checked'));
    if (checkedBoxes.length === 0) return;

    const items = checkedBoxes.map((box) => ({
      id: box.dataset.variantId,
      quantity: 1
    }));

    checkedBoxes.forEach((box) => (box.disabled = true));

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    })
      .then((res) => res.json())
      .then(() => refreshCartUI())
      .catch((err) => console.error('Addon add error:', err))
      .finally(() => {
        checkedBoxes.forEach((box) => {
          box.disabled = false;
          box.checked = false;
        });
      });
  });

  function refreshCartUI() {
    fetch(`${window.location.pathname}?sections=cart-icon-bubble,cart-drawer`)
      .then((res) => res.json())
      .then((sections) => {
        const parser = new DOMParser();

        if (sections['cart-icon-bubble']) {
          const newBubble = parser
            .parseFromString(sections['cart-icon-bubble'], 'text/html')
            .querySelector('#cart-icon-bubble');
          const currentBubble = document.getElementById('cart-icon-bubble');
          if (newBubble && currentBubble) currentBubble.innerHTML = newBubble.innerHTML;
        }

        if (sections['cart-drawer']) {
          const newDrawer = parser
            .parseFromString(sections['cart-drawer'], 'text/html')
            .querySelector('cart-drawer');
          const currentDrawer = document.querySelector('cart-drawer');
          if (newDrawer && currentDrawer) currentDrawer.innerHTML = newDrawer.innerHTML;
        }
      })
      .catch((err) => console.error('Cart refresh error:', err));
  }
});